export default "__VITE_ASSET__B08Bwa3S__"